module.exports = __webpack_public_path__ + "img/bank_logo_ktb.7164d51d.png";